// extracted by mini-css-extract-plugin
module.exports = {"grid":"payment-grid_grid__TqntL","minWidth":"payment-grid_minWidth__2yIQy"};